import React from 'react'
import { ExperienceMapper } from '@ninetailed/experience.js-utils'
import { Experience } from '@ninetailed/experience.js-gatsby'
import _helpers from '@toasttab/shared/src/globals/_helpers'

/**
 * Higher-Order Component (HOC) to wrap a React component with Ninetailed Experience.
 *
 * This function takes a component and a data node, then applies Ninetailed experiences
 * if they exist. It ensures the correct experiences are passed to the `Experience` component
 * while maintaining proper component context.
 *
 * @param {React.ComponentType<any>} Component - The React component to be wrapped.
 * @param {any} node - The data node containing Ninetailed experience configurations.
 * @param {boolean} [pageComponent=false] - Determines whether the component is a page-level component.
 * @returns {JSX.Element} - A React component wrapped with Ninetailed experience handling.
 */

const disable9TCookie = _helpers.getCookie('disable9T')
const disableNinetailed = disable9TCookie === '1'

const withNinetailedExperience = (
  Component: React.ComponentType<any>,
  node: any,
  pageComponent: boolean = false
) => (
  <Experience
    {...node}
    id={node.contentful_id}
    key={node.contentful_id}
    component={
      pageComponent
        ? (props: any) => (
            <Component
              {...props}
              context={node.context} // Ensures proper context is passed to the component
            />
          )
        : Component
    }
    experiences={((!disableNinetailed && node.nt_experiences) || [])
      // Filters only valid Ninetailed experience entries
      .filter(ExperienceMapper.isExperienceEntry)
      // Maps experiences to the format expected by Ninetailed
      .map(ExperienceMapper.mapExperience)}
  />
)

export default withNinetailedExperience
